import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { useDispatch } from "react-redux";
import { setAlert } from "../../redux/alert/alert.action";
import axios from "axios";
import closeicon from "../../Images/crossicon.svg";
import { useNavigate } from "react-router-dom";
import { CLEAR_ALLDATA } from "../../redux/auth/auth.type";
import "./deleteaccount.less";

function DeleteUserModal({ open, handleClose, setLoading, deleteNotification }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const handleDelete = async (status) => {
    setLoading(true);
    if (!token) return;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/account-delete-request`,
        {status: typeof status === "string" ? status : "approved"},
        {
          headers: {
            accessToken: token,
            Authorization:
              "Basic " +
              btoa(
                process.env.REACT_APP_USERNAME +
                  ":" +
                  process.env.REACT_APP_PASSWORD
              ),
          },
        }
      );

      if (response.data.status === 200) {
        dispatch(
          setAlert({
            alertType: "success",
            alertMsg: response?.data?.message,
            alertOpen: true,
          })
        );
        deleteNotification()
        // setTimeout(() => {
        //   dispatch({ type: CLEAR_ALLDATA });
        //   localStorage.clear();
        //   navigate("/");
        //   window.location.reload();
        // }, 2000);
      } else {
        setLoading(false);
        dispatch(
          setAlert({
            alertType: "error",
            alertMsg: response?.data?.error?.message || "Something went wrong.",
            alertOpen: true,
          })
        );
      }
    } catch (err) {
      setLoading(false);
      const status = err?.response?.data?.status;

      dispatch(
        setAlert({
          alertType: "error",
          alertMsg:
            err?.response?.data?.error?.message ||
            "Something went wrong! Please try again.",
          alertOpen: true,
        })
      );

      if (status === 401) {
        dispatch({ type: CLEAR_ALLDATA });
        localStorage.clear();
        navigate("/");
        window.location.reload();
      }
    } finally {
        handleClose()
    }
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Modal
      centered
      style={{ minWidth: isMobile ? "90%" : "450px" }}
      footer={null}
      open={open}
      onCancel={handleDelete}
      className="deletemodal"
      closable={false}
    >
      <div className="crossImage" style={{ marginBottom: "20px" }}>
        <img
          alt="close"
          src={closeicon}
          className="text-center"
          style={{ display: "flex", justifyContent: "center" }}
        />
      </div>

      <h2
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "20px",
          marginLeft: "38px",
          fontWeight: "bold",
        }}
        className="deleteheading"
      >
        Account Deletion Request
      </h2>
      <p style={{padding: "0 15px"}}>Due to inactivity, your account will be deleted in 10 days, Want to keep the account active?</p>

      <div className="confirmButtons common-button-yes-no">
        <Button className="yes-button" onClick={handleDelete}>
          Yes
        </Button>
        <Button className="no-button" onClick={() => handleDelete("rejected")}>
          No
        </Button>
      </div>
    </Modal>
  );
}

export default DeleteUserModal;
